import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {PermissionWizardContainerModel} from '../../../../../models/aggregates/permissions';

// https://api.akaun.com/core2/platform/dm/app-permission-templates/with-target

@Injectable({
  providedIn: 'root'
})
export class PermissionWizardService extends BaseApiTemplateService<PermissionWizardContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-permission-templates/with-target';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX +'app-permission-templates/with-target';
    this.httpClient = http;
  }
}


